module.exports = __webpack_public_path__ + "images/bug_turquoise_size_6_b06a142e6dcb972899cbef1ad2bdb143.png";